module.exports = __webpack_public_path__ + "img/bg2.d2e9806f.png";